export default {
	INGREDIENT_PRICINGS: 'Ingredient Pricing Groups',
	TABLE_MODAL_HEADER_CATEGORY: 'Category Name'
};
